module.exports = __webpack_public_path__ + "img/5.88a6bc57.jpg";